<template>
  <router-view v-if="project" :project.sync="project" />
  <span v-else />
</template>

<script>

import $api from '@/libs/OAuth2/services/api';

export default {
  name: 'project-frame',
  data () {
    return {
      project: null,
    };
  },
  watch: {
    project: {
      handler (newVal) {
        this.$root.project = newVal;
      },
      immediate: true,
    },
  },
  destroyed () {
    this.$root.project = null;
  },
  beforeRouteEnter (to, from, next) {
    const id = to.params?.id;
    if (!id) {
      return next(from);
    }

    $api.fetchProject(id)
      .then(res => res.data)
      .then(data => {
        if (!data) {
          return next(from);
        }

        next(vm => {
          vm.project = data;
        });
      })
      .catch(() => next(from))
    ;
  },
};

</script>
